/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ActivityType {
  Job = 0,
  Lead = 1,
  Order = 3,
}
